export enum CloseReason {
  InactiveTab = 'InactiveTab',
  NoConnectionRequired = 'NoConnectionRequired',
}

export enum WebSocketStatus {
  UNINSTANTIATED = -1,
  CONNECTING = 0,
  OPEN = 1,
  CLOSING = 2,
  CLOSED = 3,
}

export const NORMAL_CLOSURE = 1000;
export const DEFAULT_RECONNECT_INTERVAL = 500;

export interface BaseWsOptions {
  onOpen?: (event: WebSocketEventMap['open']) => void;
  onClose?: (event: WebSocketEventMap['close']) => void;
  onMessage?: (event: WebSocketEventMap['message']) => void;
  onError?: (event: WebSocketEventMap['error']) => void;
  onReconnectStop?: (numAttempts: number) => void;
  shouldReconnect?: (event: WebSocketEventMap['close']) => boolean;
  reconnectInterval?: number | ((lastAttemptNumber: number) => number);
  reconnectAttempts?: number;
  retryOnError?: boolean;
}

export interface BaseWsInstance {
  sendMessage: (message: string) => void;
  lastMessage: WebSocketEventMap['message'] | null;
  getWebSocket: () => WebSocket | null;
  status: WebSocketStatus;
  isConnected: boolean;
  connect: () => void;
  disconnect: (code?: number, reason?: CloseReason) => void;
  reconnectAttempt: number;
}

export const getReconnectDelay = (
  attemptNumber: number,
  reconnectInterval: BaseWsOptions['reconnectInterval']
): number => {
  if (typeof reconnectInterval === 'function') {
    return reconnectInterval(attemptNumber);
  }

  if (typeof reconnectInterval === 'number') {
    return reconnectInterval;
  }

  return DEFAULT_RECONNECT_INTERVAL;
};
